import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { StyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';

const Label = styled('label')`
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${hexToRgba(StyleColor.White, 75)};
`;

const Icon = styled('div')`
	position: absolute;
	top: 8px;
	left: 13px;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	color: ${hexToRgba(StyleColor.White, 75)};

	svg {
		width: 100%;
		height: 100%;
		fill: currentColor;
	}
`;

const Hint = styled(Translate)`
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 16px;
	color: ${hexToRgba(StyleColor.White, 75)};
`;

export {
	Label,
	Icon,
	Hint,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SettingsPanel/FieldPanel/styles.ts